(() => {
  const push = (event, detail = {}) => {
    const payload = {
      event,
      mue: {
        ...detail,
        page_type: document.querySelector('main[data-template]')?.dataset.template || '',
        page_path: window.location.pathname,
        timestamp: new Date().toISOString(),
      },
    };

    window.mueDataLayer = window.mueDataLayer || [];
    window.mueDataLayer.push(payload);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);

    if (typeof window.Shopify?.analytics?.publish === 'function') {
      Promise.resolve(window.Shopify.analytics.publish(`mue:${event}`, payload.mue)).catch(() => {});
    }
    document.dispatchEvent(new CustomEvent(`mue:${event}`, { detail: payload.mue }));
  };

  const productData = (card) => ({
    product_id: card.dataset.productId || '',
    product_title: card.dataset.productTitle || '',
    product_vendor: card.dataset.productVendor || '',
    product_price: Number.parseFloat(card.dataset.productPrice || '0'),
    currency: card.dataset.productCurrency || '',
    context: card.dataset.productContext || '',
  });

  const init = () => {
    if (document.documentElement.dataset.mueAnalyticsReady === 'true') return;
    document.documentElement.dataset.mueAnalyticsReady = 'true';

    let listViewTracked = false;
    const trackProductList = () => {
      if (listViewTracked) return true;

      const cards = [...document.querySelectorAll('[data-mue-product-card]')];
      document.documentElement.dataset.mueProductCardCount = String(cards.length);
      if (!cards.length) return false;

      push('product_list_view', {
        collection_handle: window.location.pathname.split('/collections/')[1]?.split('/')[0] || '',
        visible_product_ids: cards.map((card) => card.dataset.productId).filter(Boolean),
        product_count: cards.length,
      });
      listViewTracked = true;
      document.documentElement.dataset.mueListViewTracked = 'true';
      return true;
    };

    if (!trackProductList()) {
      const observer = new MutationObserver(() => {
        if (trackProductList()) observer.disconnect();
      });
      observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
      window.addEventListener('load', trackProductList, { once: true });
      window.setTimeout(() => {
        trackProductList();
        observer.disconnect();
      }, 10000);
    }

    document.addEventListener('click', (event) => {
      const trackedLink = event.target.closest('[data-mue-track]');
      if (trackedLink) {
        push(trackedLink.dataset.mueTrack, {
          label: trackedLink.dataset.mueLabel || trackedLink.textContent.trim().replace(/\s+/g, ' '),
          item_index: trackedLink.dataset.mueIndex || '',
          destination: trackedLink.href || '',
        });
      }

      const link = event.target.closest('[data-mue-product-card] a[href*="/products/"]');
      if (!link) return;

      push('product_click', {
        ...productData(link.closest('[data-mue-product-card]')),
        destination: link.href,
      });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-mue-search-form]');
      if (!form) return;

      const query = new FormData(form).get('q')?.toString().trim() || '';
      push('search_submit', {
        search_source: form.dataset.mueSearchForm || 'site',
        search_query: query,
        query_length: query.length,
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        push('cart_update', {
          source: event?.source || '',
          variant_id: event?.variantId || '',
          item_count: event?.cartData?.item_count,
          cart_total: event?.cartData?.total_price,
        });
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
